import React, { useState } from 'react'
import GridContainer from '@naturacosmeticos/natds-web/dist/Components/GridContainer'
import GridItem from '@naturacosmeticos/natds-web/dist/Components/GridItem'
import Paper from '@material-ui/core/Paper'
import withStyles from '@material-ui/core/styles/withStyles'
import ReactCardFlip from 'react-card-flip'
import Grid from '@material-ui/core/Grid'
import FlipButton from './FlipButton'

const styles = theme => ({
  containerPaperWhite: {
    padding: '19px 16px',
    paddingTop: '7px',
    paddingBottom: '7px',
    background: theme.palette.common.white
  },
  containerPaperGrey: {
    padding: '9px 16px',
    background: '#eeeeee',
    paddingBottom: '0px'
  },
  productImage: {
    width: '240px',
    margin: '0 auto'
  },
  earningsCalculatorProductsTitle: {
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '0.7rem;',
    letterSpacing: '0.22px',
    lineHeight: 1.5,
    marginBottom: 0,
    marginTop: 0
  },
  earningsCalculatorProductsDescription: {
    marginTop: 0,
    marginBottom: '16px',
    textAlign: 'left',
    fontSize: '0.7rem',
    lineHeight: 1.5,
    float: 'left'
  },
  noSpacing: {
    marginBottom: 0
  },
  cardInfoSpacing: {
    marginLeft: '8px'
  }
})

const renderProduct = (product, classes) => {
  const {
    excerpt,
    frontmatter: { title, order, price },
    id
  } = product.node

  return (
    <GridItem xs={12} key={id}>
      <p className={classes.earningsCalculatorProductsTitle}>
        {order}. {title}
        {price && `: ${price}`}
      </p>
      <p className={classes.earningsCalculatorProductsDescription}>
        {excerpt}
      </p>
    </GridItem>
  )
}

const EarningsCalculatorCardMobile = ({ 
  classes,
  products,
  catalog,
  productsImage,
  tabActive
}) => {
  const [toggleView, setToggleView] = useState(true)

  return (
    <>
      <FlipButton
        onClick={() => setToggleView(!toggleView)}
        flipped={toggleView}
      />
      <ReactCardFlip isFlipped={!toggleView}>
        <Paper
          className={classes.containerPaperWhite}
          onClick={() => setToggleView(!toggleView)}
        >
          <Grid container>
            <Grid className={classes.productImage} item>
              {productsImage}
            </Grid>
          </Grid>
        </Paper>
        <Paper
          className={classes.containerPaperGrey}
          onClick={() => setToggleView(!toggleView)}
        >
          <GridContainer>
            { (tabActive !== 1 && catalog) ? (
              catalog.map(product => renderProduct(product, classes))
            ) : (
              products.map(product => renderProduct(product, classes))
            )}
          </GridContainer>
        </Paper>
      </ReactCardFlip>
    </>
  )
}

export default withStyles(styles)(EarningsCalculatorCardMobile)
